var splice = require('../array/virtual/splice');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.splice;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.splice) ? splice : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/splice.js
// module id = 993
// module chunks = 0